import React, {memo} from "react";
import Modal from "react-bootstrap/Modal";
import "react-datepicker/dist/react-datepicker.css";
import DineInSwitcher from "./DineInSwitcher";
import DineInFloorSwitcher from "./DineInFloorSwitcher";
import TableLayoutWithBg from "./DineInTableLayout";
import useTableFunctions from "../hooks/useTableFunctions";

const guestVisitor = [2, 5, 8, 10, 15];
const NewTableModal = ({
  modal10Show,
  setModal10Show,
  setOrderDetails,
  orderDetails,
  selectedDeliveryType,
  selectTable,
  setSelectTable,
  guestSelected,
  setGuestSelected,
  tableId,
  setTableId,
  selectedParty,
  selectedDeptTag,
  buttonDisabled,
}) => {
  const {
    waiterSelected,
    setWaiterSelected,
    getTableFloor,
    tablefloor,
    setTableFloor,
    multiSelect,
    setMultiSelect,
    tables,
    startDate,
    setStartDate,
    startTime,
    setStartTime,
    endTime,
    setEndTime,
    newtable,
    setNewTable,
    handleTableSubmit,
    handleTableSelect,
    handleTableMulitpleSelect,
    handleSplit,
    handleSearchWaiter,
    waitersList,
    tableLoading,
  } = useTableFunctions({
    orderDetails,
    buttonDisabled,
    selectedDeptTag,
    selectedDeliveryType,
    selectedParty,
    setOrderDetails,
    orderDetails,
    setModal10Show,
    selectTable,
    setSelectTable,
    tableId,
    setTableId,
    guestSelected,
    setGuestSelected,
  });

  // const [remainingPallete, setRemainingPallete] = useState([]);
  // const { waiters, setWaiters, waiterSelected, setWaiterSelected, getTableFloor, tablefloor, setTableFloor } = useFilteredFloorWaiters(orderDetails);

  // const [multiSelect, setMultiSelect] = useState(false);
  // const [tables, setTables] = useState([]);
  // const [tablesApi, setTableApi] = useState([]);
  // const [tempIndex, setTempIndex] = useState(null);
  // const [startDate, setStartDate] = useState(new Date());
  // const [startTime, setStartTime] = useState(new Date());
  // const [endTime, setEndTime] = useState(new Date());

  // //get table with api
  // useEffect(() => {
  //     if (tableForSearch && orderDetails.branch) {
  //         let getTableStatus = tableForSearch && tableForSearch.filter((tableSearch) => {
  //             return parseInt(tableSearch.branch_id) === orderDetails.branch?.id && tableSearch.status === "1"
  //         });

  //         if (!buttonDisabled) {
  //             setTables(getTableStatus);
  //             setTableApi(getTableStatus);
  //         }

  //         getTableStatus && getTableStatus.map((table) => {
  //             const index = colorPallete.findIndex((color) => color === (table.is_color));
  //             if (index !== -1) {
  //                 return colorPallete.splice(index, 1);
  //             }
  //             setRemainingPallete(colorPallete)
  //         });

  //         if (order_id && getTableStatus) {
  //             const newTable = [...getTableStatus];
  //             let selectedTable = {};
  //             let tabel = orderDetails.table && orderDetails.table?.forEach((table) => {
  //                 if (getTableStatus && getTableStatus?.length > 0) {
  //                     const index = getTableStatus.findIndex((tableIndex) => table?.id === tableIndex.id);
  //                     newTable[index] && setTempIndex(index);
  //                     if (newTable[index].is_reserved === 2 && newTable[index].is_split === 1) {
  //                         newTable[index] = { ...newTable[index], is_reserved: 1 };
  //                     } else {
  //                         newTable[index] = { ...newTable[index], is_reserved: 0 };
  //                     }
  //                     selectedTable = {
  //                         ...selectedTable,
  //                         [table.id]: {
  //                             ...table,
  //                             ...((table.is_reserved === 2 && table.is_split === 1) ? { is_reserved: 1 } : { is_reserved: 0 })
  //                         }
  //                     }
  //                 }
  //             });
  //             setTables(newTable);
  //             setTableApi(newTable);
  //             setSelectTable(selectedTable);
  //         }
  //     }
  // }, [tableForSearch, orderDetails?.branch]);

  // const [newtable, setNewTable] = useState(null);

  // // multi select option
  // useEffect(() => {
  //     if (!buttonDisabled && Object.values(selectTable)[0]) {
  //         setTables(tablesApi);
  //         setSelectTable({});
  //         setOrderDetails((curr) => {
  //             const newData = {
  //                 ...curr,
  //                 table: null,
  //                 waiter: waiterSelected ? waiterSelected : null,
  //                 total_guest: guestSelected ? guestSelected : 1,
  //                 table_id: null,
  //                 table_name: null,
  //             }
  //             return newData
  //         });
  //     }
  // }, [multiSelect, tablefloor, selectedDeliveryType, orderDetails?.branch, selectedDeptTag, selectedParty]);

  // useEffect(() => {
  //     // search waiter acc to branch
  //     // if (orderDetails.branch) {
  //     //   let tempWaiters =
  //     //     waiterForSearch !== null &&
  //     //     waiterForSearch.filter((eachWaiter) => {
  //     //       return parseInt(eachWaiter.branch_id) === orderDetails?.branch.id;
  //     //     });
  //     //   setWaiter(tempWaiters);
  //     // }

  //     if (order_id) {
  //         setWaiterSelected(orderDetails?.waiter ? orderDetails?.waiter : "");
  //         setGuestSelected(
  //             orderDetails?.total_guest ? parseInt(orderDetails?.total_guest) : 1
  //         );
  //         if (history.location?.search?.startsWith("?table_merge=") || (orderDetails.table && orderDetails.table?.length > 0 && orderDetails.table[0].is_merge)) {
  //             setMultiSelect(true);
  //         }
  //     }
  // }, [selectedDeliveryType, orderDetails?.branch]);

  // //selected tables in state for final playload
  // useEffect(() => {
  //     if (selectTable) {
  //         //let table_Id = [];
  //         let tables = Object.values(selectTable)
  //         // let tableid = Object.keys(selectTable)?.map(id => table_Id.push(parseInt(id)));
  //         let tableid = Object.keys(selectTable)?.map(id => parseInt(id));
  //         setNewTable(tables);
  //         setTableId(tableid);
  //     }
  // }, [selectTable]);

  // const handleTableSubmit = (e) => {
  //     e.preventDefault();
  //     const tableValidation = selectedDeliveryType && selectedDeliveryType.name.match(/dine(.*)in/i) &&
  //         parseInt(getSystemSettings(generalSettings, "table_waiter")) === 1;
  //     const waiterOd = getSystemSettings(generalSettings, "waiter_order_type") ? JSON.parse(getSystemSettings(generalSettings, "waiter_order_type")) : null;

  //     if (tableValidation) {
  //         if (selectTable && Object.keys(selectTable)?.length > 0) {
  //             if (Object.values(selectTable)[0].is_reserved && Object.values(selectTable)[0].is_split === 0) {
  //                 toast.error("Table is already reserved");
  //                 return false;
  //             }
  //             if (waiterOd && waiterOd.length && (waiterOd.includes(selectedDeliveryType.id) && !waiterSelected)) {
  //                 toast.error("Please select waiter");
  //                 return false;
  //             }
  //             setOrderDetails((curr) => ({
  //                 ...curr,
  //                 table: newtable ? newtable : null,
  //                 waiter: waiterSelected ? waiterSelected : null,
  //                 total_guest: guestSelected ? guestSelected : 1,
  //                 table_id: tableId,
  //                 table_name: Object.values(selectTable)[0]?.name,
  //             }));
  //             setModal10Show(false);
  //         } else {
  //             toast.error("Please select the table first");
  //         }
  //     } else {
  //         if (waiterOd && waiterOd.length && (waiterOd.includes(selectedDeliveryType.id) && !waiterSelected)) {
  //             toast.error("Please select waiter");
  //             return false;
  //         }
  //         setOrderDetails((curr) => ({
  //             ...orderDetails,
  //             waiter: waiterSelected ? waiterSelected : null,
  //         }));
  //         setModal10Show(false);
  //     }
  // };

  // const handleTableSelect = (table, index) => {
  //     if (selectTable && Object.values(selectTable)[0]?.is_split === 1 && Object.values(selectTable)[0]?.is_reserved === 0) {
  //         toast.error("Please un split the selected split table");
  //         setTempIndex(null)
  //     } else {
  //         setTempIndex(index)
  //         if (Object.keys(selectTable).includes(table.id.toString())) {
  //             setSelectTable((curr) => {
  //                 const tabel = {
  //                     ...curr,
  //                 };
  //                 delete tabel[table.id]
  //                 return tabel;
  //             });

  //         } else {
  //             if (table.is_split && table.is_reserved) {
  //                 setSelectTable({
  //                     [table.id]: {
  //                         ...table,
  //                         name: table?.name + "-B",
  //                         is_color: "",
  //                         is_merge: 0
  //                     }
  //                 });
  //             } else {
  //                 if (table.is_reserved) {
  //                     setSelectTable({
  //                         [table.id]: {
  //                             ...table,
  //                             is_split: 0,
  //                             is_merge: 0,
  //                             is_color: "",
  //                         },
  //                     });
  //                 } else {
  //                     setSelectTable({
  //                         [table.id]: {
  //                             ...table,
  //                             is_split: 0,
  //                             is_reserved: 0,
  //                             is_merge: 0,
  //                             is_color: "",
  //                         },
  //                     });
  //                 }
  //             }
  //         }
  //     }
  // };

  // // multiple table select
  // const handleTableMulitpleSelect = (table, ind) => {
  //     if (table.is_split === 1 || table.is_reserved) {
  //         toast.error("You can't select split/reserve table on multiselect");
  //     } else {
  //         if (Object.keys(selectTable).includes(table.id.toString())) {
  //             const newTable = [...tables];
  //             if (ind !== -1) {
  //                 [newTable[ind]] = [{ ...newTable[ind], is_merge: 0, is_color: "" }];
  //             }
  //             setTables(newTable);
  //             setSelectTable((curr) => {
  //                 const tabel = {
  //                     ...curr,
  //                 };
  //                 delete tabel[table.id]
  //                 return tabel;
  //             });
  //         } else {
  //             // let selectedTable = [table,...Object?.values(selectTable)];
  //             const newTable = [...tables];
  //             [newTable[ind]] = [{ ...newTable[ind], is_merge: 1 }];
  //             setSelectTable((curr) => {
  //                 const mergetabel = {
  //                     ...curr,
  //                     [newTable[ind].id]: {
  //                         ...newTable[ind],
  //                         is_color: remainingPallete[0],
  //                         is_merge: 1,
  //                         is_reserved: 0,
  //                         is_split: 0
  //                     },
  //                 };
  //                 return mergetabel;
  //             });
  //             setTables(newTable);
  //         }

  //     }
  // };

  // // split table
  // const handleSplit = () => {
  //     if (Object.keys(selectTable)?.length > 0) {
  //         if (multiSelect === true) {
  //             toast.error("Please turn off multi select option")
  //         } else {
  //             // const index2 = tables.findIndex((table) => Object.values(selectTable)[0].id === (table.id));
  //             const index2 = tempIndex;
  //             if (tables[index2]?.is_split === 1 && tables[index2]?.is_reserved === 0) {
  //                 if (index2 !== -1) {
  //                     const newTable = [...tables];
  //                     [newTable[index2]] = [{ ...newTable[index2], is_split: 0 }];
  //                     setTables(newTable);
  //                 }
  //                 setSelectTable({});
  //             } else if (tablesApi[index2]?.is_split === 1 && tablesApi[index2]?.is_reserved === 1) {
  //                 toast.error("Already Split");
  //                 setSelectTable({});
  //             } else if (tables[index2]?.is_reserved === 1) {
  //                 if (tables[index2]?.id === Object.values(selectTable)[0]?.id && Object.values(selectTable)[0]?.is_split) {
  //                     if (index2 !== -1) {
  //                         const newTable = [...tables];
  //                         [newTable[index2]] = [{ ...newTable[index2], is_split: 0, }];
  //                         setTables(newTable);
  //                     }
  //                     setSelectTable({});
  //                 } else {
  //                     if (index2 !== -1) {
  //                         const newTable = [...tables];
  //                         [newTable[index2]] = [{ ...newTable[index2], is_split: 1, }];
  //                         setTables(newTable);
  //                     }
  //                     setSelectTable({
  //                         [Object.values(selectTable)[0].id]: {
  //                             ...Object.values(selectTable)[0],
  //                             name: Object.values(selectTable)[0].name + "-B",
  //                             is_color: "",
  //                             is_merge: 0,
  //                             is_split: 1,
  //                             is_reserved: 1
  //                         },
  //                     });
  //                 }
  //             } else {
  //                 if (index2 !== -1) {
  //                     const newTable = [...tables];
  //                     [newTable[index2]] = [{ ...newTable[index2], is_split: 1, is_reserved: 0 }];
  //                     setTables(newTable);
  //                 }
  //                 setSelectTable({
  //                     [Object.values(selectTable)[0].id]: {
  //                         ...Object.values(selectTable)[0],
  //                         name: Object.values(selectTable)[0].name + "-A",
  //                         is_color: "",
  //                         is_merge: 0,
  //                         is_split: 1,
  //                         is_reserved: 0
  //                     },
  //                 });
  //             }

  //         }
  //     } else {
  //         toast.error("Please Select Table");
  //     }
  // };

  // //waiter search
  // const handleSearchWaiter = (e) => {
  //     const search = e.target.value.toLowerCase();
  //     if (search?.length) {
  //         const searchedWaiter = waiters.waiterList && waiters.waiterList.filter((waiter) => waiter.name.toLowerCase().includes(search));
  //         setWaiters({
  //             ...waiters,
  //             searchedWaiter: searchedWaiter,
  //         })
  //     } else {
  //         setWaiters({
  //             ...waiters,
  //             searchedWaiter: null,
  //         })
  //     }
  // }

  // const waitersList = waiters.searchedWaiter || waiters.waiterList;

  // const handleTranfer = () =>{
  //   if (Object.keys(selectTable)?.length > 1) {
  //     if(multiSelect === true){
  //       const index1 = tables.findIndex((table) => Object.keys(selectTable)[0] === (table.id));
  //       const index2 = tables.findIndex((table) => Object.keys(selectTable)[1] === (table.id));
  //       if (index1 !== -1 && index2 !== -1) {
  //         const newTable = [...tables];
  //         [newTable[index1], newTable[index2]] = [newTable[index2], newTable[index1]];
  //         setTables(newTable);
  //       }
  //     }else{
  //       toast.error("Please select table from multiselect option")
  //     }
  //   }else{
  //     toast.error("Please select two tables to tranfer")
  //   }
  // }

  return (
    <Modal
      show={modal10Show}
      onHide={() => setModal10Show(false)}
      size="table"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="dine-in-modal-body">
        {/* Modal Body */}
        <div style={{ padding: "0.5rem" }}>
          <form onSubmit={(e) => handleTableSubmit(e)} autoComplete="off">
            <div className="main row">
              <div
                className="col-8  d-flex align-items-center"
                style={{ gap: "1.3rem" }}
              >
                <h4 className="font-weight bold mb-0  table-header ">
                  Table Selection
                </h4>
                <DineInSwitcher setMultiSelect={setMultiSelect} />
              </div>
              <div className="col-8">
                <div className="flex-row d-flex justify-content-between border-bottom pb-0 align-items-center">
                  {getTableFloor && (
                    <DineInFloorSwitcher
                      setTableFloor={setTableFloor}
                      getTableFloor={getTableFloor}
                      tablefloor={tablefloor}
                    />
                  )}
                </div>
                <TableLayoutWithBg
                  tables={tables}
                  tablefloor={tablefloor}
                  selectTable={selectTable}
                  multiSelect={multiSelect}
                  tableLoading={tableLoading}
                  handleTableMulitpleSelect={handleTableMulitpleSelect}
                  handleTableSelect={handleTableSelect}
                />
                <div className="d-flex justify-content-between align-items-center   table-status-container">
                  <div className="d-flex align-items-center status-wrapper">
                    <span className="fw-bold me-2">Table Status:</span>
                    <span className="status-box bg-free"></span>
                    <span className="status-label">Free</span>
                    <span className="status-box bg-reserve ms-3"></span>
                    <span className="status-label">Reservation</span>
                    <span className="status-box bg-occupied ms-3"></span>
                    <span className="status-label">Occupied</span>
                  </div>

                  <button
                    type="button"
                    className="btn fw-bold split-btn"
                    onClick={handleSplit}
                  >
                    {selectTable && Object.values(selectTable)[0]?.is_split
                      ? "Unsplit Table"
                      : "Split Table"}
                  </button>
                </div>
              </div>
              <div
                className="col-4 border-left d-flex justify-content-between right-dine-in-container"
                style={{
                  flexDirection: "column",
                }}
              >
                <div className="col ml-2">
                  {/* <div className="col-12 ">
                
                <label className="mb-1 col-form-label class-variants" style={{color:"#0a8d6e"}}>
               
                <input
                disabled = {order_id}
                type="checkbox"
                className="form-check-input pointer-cursor mr-2"
                name="reservation"
                value = "1"
                onChange={(e)=>{
                  setOrderDetails({
                    ...orderDetails,
                    reservation: orderDetails.reservation === 1 ? 0 : 1,
                  })
                }}
                checked ={
                  orderDetails.reservation ? 1 : 0
                }

                />
                Table Reservation
                </label>
                <br/>
                 {
                  orderDetails.reservation === 1 &&(
                    <>
                
                    <label
                    for="recipient-name"
                    className="col-form-label fw-bold class-variants"
                  >
                    Date
                  </label>
                  <DatePicker
                   required={true}
                    minDate={new Date()}
                    selected={startDate}
                    value={startDate}
                    onChange={(date) => setStartDate(date)}
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    className="form-control sm-text py-2 t-mb-15 mb-md-0"
                    shouldCloseOnSelect={true}
                  />
                    <div className="col-12 ">
                    <label
                      for="recipient-name"
                      className="col-form-label fw-bold class-variants"
                    >
                      Time
                    </label>
                    <div className="d-flex align-items-center">
                    <span className="col mr-2">
                    <DatePicker
                    minDate={new Date().getTime()}
                    selected={startTime}
                    value={startTime}
                    onChange={(date) =>  setStartTime(date.getTime())}
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="h:mm aa"
                     showTimeSelect
                     showTimeSelectOnly
                     dropdownMode="select"
                     className="form-control sm-text py-2 t-mb-15 mb-md-0 col-6"
                     shouldCloseOnSelect={true}
                   />
                   </span>

                   <span className="col ml-1">
                   <DatePicker
                  minDate={new Date().getTime()}
                  selected={endTime}
                  value={endTime}
                  onChange={(date) =>  setEndTime(date.getTime())}
                  timeIntervals={15}
                  timeCaption="Time"
                  dateFormat="h:mm aa"
                  showTimeSelect
                  showTimeSelectOnly
                  dropdownMode="select"
                  className="form-control sm-text py-2 t-mb-15 mb-md-0 col-6"
                  shouldCloseOnSelect={true}
                  />
                  </span>
                  </div>
                  </div>
                    </>
                  )
                 }
                  
                 </div> */}
                  <div className="col-12" style={{ marginTop: "-1rem" }}>
                    <label
                      htmlFor="guest"
                      className="col-form-label fw-bold class-variants"
                    >
                      Guest
                    </label>
                    <div className="w-50 mb-1 d-flex align-items-center position-relative counter-dn">
                      <button
                        type="button"
                        className="btn btn-decrement"
                        onClick={() =>
                          guestSelected == 1
                            ? 1
                            : setGuestSelected(Number(guestSelected) - 1)
                        }
                      >
                        {" "}
                        −{" "}
                      </button>
                      <input
                        type="number"
                        id="guest"
                        min="0"
                        step="1"
                        onKeyDown={(evt) =>
                          ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(
                            evt.key
                          ) && evt.preventDefault()
                        }
                        onWheel={(e) => e.target.blur()}
                        className="form-control table-text text-center lg-text p-2 px-3 rounded-xlg"
                        value={guestSelected}
                        onChange={(e) => setGuestSelected(e.target.value)}
                        placeholder={1}
                        required
                      />
                      <button
                        type="button"
                        className="btn btn-primary btn-increment"
                        onClick={() =>
                          setGuestSelected(Number(guestSelected) + 1)
                        }
                      >
                        +
                      </button>
                    </div>
                    <div className="d-flex align-items-center mt-3 flex-wrap selected-counter-btns">
                      {guestVisitor &&
                        guestVisitor.map((guest, index) => {
                          return (
                            <div key={index} className="p-1 mb-1 text-break">
                              <button
                                type="button"
                                className={`p-0 btn-custom rounded-sm btn btn-sm ${
                                  guest === guestSelected
                                    ? "btn-success"
                                    : "btn-primary"
                                } table-text`}
                                onClick={() => {
                                  setGuestSelected(guest);
                                }}
                              >
                                {guest}
                              </button>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                  <div className="col-12 waiter">
                    <label
                      htmlFor="waiter"
                      className="col-form-label fw-bold class-variants  "
                    >
                      Waiter
                    </label>
                    <div className="mb-3">
                      <input
                        className="form-control table-text rounded-sm"
                        id="waiter"
                        placeholder="Search waiter"
                        onChange={(e) => handleSearchWaiter(e)}
                      />
                    </div>
                    <div className="waiter-button-container ">
                      <div className="waiter-button-list">
                        {waitersList &&
                          waitersList?.map((waiter, index) => (
                            <button
                              key={index}
                              type="button"
                              className={`waiter-button ${
                                waiter.id === waiterSelected?.id
                                  ? "waiter-selected"
                                  : ""
                              } `}
                              onClick={() =>
                                setWaiterSelected(
                                  waiterSelected?.id === waiter?.id
                                    ? null
                                    : waiter
                                )
                              }
                            >
                              {waiter?.name}
                            </button>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col ml-2 d-flex justify-content-end dine-in-confirm-btn-foot"
                  style={{
                    flexDirection: "column",
                  }}
                >
                  <Modal.Footer
                    style={{
                      borderTop: "none",
                      display: "block",
                      padding: "0.3rem 0rem",
                    }}
                  >
                    <div className="footer-button-container dine-in-confirm-btn-foot ">
                      <button type="submit" className="footer-button confirm">
                        Confirm
                      </button>
                      <button
                        type="button"
                        className="footer-button cancel"
                        onClick={() => setModal10Show(false)}
                      >
                        Cancel
                      </button>
                    </div>
                  </Modal.Footer>
                </div>
              </div>
            </div>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default memo(NewTableModal);
